import { PermanentJobsApi } from '../clients';
import { ICreateShortlistCandidatePayload } from '../types';

export const createShortlistCandidate = async (
  payload: ICreateShortlistCandidatePayload,
): Promise<void> => PermanentJobsApi.createShortlistCandidate(payload);
